import React from "react";
import { noop } from "utils/General";
import Header from "Portal/NewPortal/HeaderBar/MobileMenuFlyOver/View/Header";
import SwitchEvents from "./SwitchEvents";

const MobileSwitchPortal = ({ handleClose = noop }) => {
  return (
    <div>
      <Header hideModal={handleClose} name="Event" xSize={16} height={56} />
      <SwitchEvents handleClose={handleClose} />
    </div>
  );
};

export default MobileSwitchPortal;
